<script>
    import NoDashboard from '../routes/NoDashboard.svelte'
    import {fade} from 'svelte/transition'

    import { Mediator } from '../lib/mediator'

    let ready = false

    let dashboardList = [
                        {
                            Name:'No Dashboard',
                            Role:'',
                            Right:''
                        }
                        ] 

    let selectedDashboard = 'No Dashboard'

    let dashboard = localStorage.getItem('dashboard')
    if (!dashboard) {
        dashboard = 'Classic'
        localStorage.setItem('dashboard','Classic')
        let index = dashboardList.findIndex((el) => el.Name == dashboard)
        if (index != -1) {
            selectedDashboard = dashboard
        }
    } else {
        selectedDashboard = dashboard
    }

    function changeDashboard(e) {
        if (dashboard != selectedDashboard) {
            dashboard = selectedDashboard
            localStorage.setItem('dashboard',dashboard)
        }
    }

</script>

<div  in:fade="{{duration: 500}}">
    <div>
        <!-- Header -->
        <header>
            <div class="row padding">
                <i class="extra">sunny</i>
                <div class="max"> 
                    <h6 class="small"><strong>Lineages of the Sun - There is nothing here</strong></h6>
                </div>
                <div class="field suffix border small">
                    <select id={'seldb'} bind:value={selectedDashboard} on:change={changeDashboard}>
                        {#each dashboardList as db}
                            {#if db.Role.length == 0}
                                <option value={db.Name} selected={db.Name==dashboard}>
                                    {db.Name}
                                </option>
                            {:else}
                                <option value={db.Name} selected={db.Name==dashboard}>
                                    {db.Name}
                                </option>
                            {/if}
                        {/each}
                    </select>
                    <i>arrow_drop_down</i>
                    <output>Default Dashboard</output>
                </div>
            </div>
        </header>
    </div>
</div>


<style>
    #defaultDashboard select {
        display: inline-block;
        width: auto;
        margin-left: 1rem;
    }
</style>